import {
  AppLayout,
  Button,
  Header,
  HelpPanel,
  SpaceBetween,
  Tabs,
} from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { AmbassadorDirectoryTable } from '../components/ambassadors/ambassadorDirectoryTable';
import { useState } from 'react';
import { AmbassadorDirectoryDosAndDonts } from '../components/ambassadors/ambassadorDirectoryDosAndDonts';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';
import { useSearchParams } from 'react-router-dom';

export function AmbassadorDirectory() {
  const [dosAndDontsOpen, setDosAndDontsOpen] = useState(false);
  const { t } = useTranslation(['ambassadors', 'translation']);

  return (
    <AppLayout
      navigationHide
      toolsHide={!dosAndDontsOpen}
      toolsOpen={dosAndDontsOpen}
      onToolsChange={() => setDosAndDontsOpen((d) => !d)}
      tools={
        <HelpPanel header={<h2>{t('ambassadorDirectory.dosAndDonts')}</h2>}>
          <AmbassadorDirectoryDosAndDonts />
        </HelpPanel>
      }
      content={
        <div>
          <SpaceBetween direction="horizontal" size="s">
            <Header variant="h1">{t('ambassadorDirectory.title')}</Header>
            <div data-directory-dos-and-donts>
              <Button onClick={() => setDosAndDontsOpen((d) => !d)} variant="inline-link">
                {t('ambassadorDirectory.dosAndDonts')}
              </Button>
            </div>
          </SpaceBetween>
          <Tabs
            tabs={[
              {
                label: t('ambassadorDirectory.global'),
                id: 'global',
                content: <AmbassadorDirectoryTable />,
              },
              {
                label: t('ambassadorDirectory.inYourArea'),
                id: 'area',
                content: (
                  <>
                    <AmbassadorDirectoryTable inYourArea />
                  </>
                ),
              },
            ]}
          />
        </div>
      }
    />
  );
}

export function AmbassadorDirectoryView() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return <AmbassadorDirectory />;
  } else {
    return <></>;
  }
}
